import React, { useEffect, useState } from 'react';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import { validateIsNotempty, validateCharecters, validateEmail, validatePassword } from '../../../utils';
// import LoadingView from '../../Loader/LoadingView';
import MenuItem from '@mui/material/MenuItem';

const CreateUser = (props) =>
{
	const { open, handleClose, handleSave, data, handleUpdate } = props;

	const [ formData, setFormData ] = useState({ fname: '', lname: '', email: '', phoneNumber: '', teamName: '', country: '', password: '', userType: '', isUnlimitedAccess: false });
	const [ errorObj, setError ] = useState({});
	// const [ isLoading, setLoading ] = useState(false);

	useEffect(() =>
	{
		if (data && data !== null)
		{
			const _data = { ...data };
			// eslint-disable-next-line quotes, no-console
			// console.log('_data ==== ', _data);

			setFormData({ ..._data });
		}
	}, [ data ]);

	const handleSubmit = () =>
	{
		const { fname, lname, email, password, userType } = formData;

		// eslint-disable-next-line quotes, no-console
		// console.log("formData ==== ", formData);
		const error = {};

		if (!validateIsNotempty(fname))
		{
			error['fname'] = 'Please Enter First Name';
		}
		else if (!validateCharecters(fname))
		{
			error['fname'] = 'First Name should contain only alphabets';
		}

		if (lname && lname !== '' && !validateCharecters(lname))
		{
			error['lname'] = 'Last Name should contain only alphabets';
		}

		if (!data || (data && data === null))
		{
			if (!validateIsNotempty(email))
			{
				error['email'] = 'Please Enter your email addtess';
			}
			else if (!validateEmail(email))
			{
				error['email'] = 'Please enter valid email';
			}

			if (!validateIsNotempty(password))
			{
				error['password'] = 'Please Enter password';
			}
			else if (!validatePassword(password))
			{
				error['password'] = 'Please enter valid password';
			}
			if (!validateIsNotempty(userType))
			{
				error['userType'] = 'Please Select the user type';
			}
		}

		if (Object.keys(error).length <= 0)
		{
			setError({});
			const body = { ...formData };

			// setLoading(true);
			if (data && data !== null)
			{
				handleUpdate(data._id, body);
			}
			else
			{
				handleSave(body);
			}
		}
		else
		{
			setError(error);
		}

	};

	const handleChange = (val, name) =>
	{
		setFormData((prevState) => { return { ...prevState, [name]: val }; });
	};

	const handleCheckboxChange = (event) =>
	{
		// eslint-disable-next-line no-console
		// console.log(event.target);

		return setFormData((prevState) => { return { ...prevState, [event.target.name]: event.target.checked }; });
	};

	return (
		<Dialog open={open}>
			<DialogTitle>Create User</DialogTitle>
			<DialogContent>
				{/* {isLoading && <LoadingView />} */}
				<TextField
					margin='dense'
					variant='standard'
					id='fname'
					label='First Name'
					type='text'
					fullWidth
					autoFocus
					required
					onChange={(e) => handleChange(e.target.value, 'fname')}
					value={formData?.fname ? formData.fname : ''}
					error={errorObj?.fname ? true : false}
					helperText={errorObj?.fname}
				/>
				<TextField
					margin='dense'
					variant='standard'
					id='lname'
					label='Last Name'
					type='text'
					fullWidth
					onChange={(e) => handleChange(e.target.value, 'lname')}
					value={formData?.lname ? formData.lname : ''}
					error={errorObj?.lname ? true : false}
					helperText={errorObj?.lname}
				/>
				{(!data || data === null) &&
				<TextField
					margin='dense'
					variant='standard'
					id='email'
					label='Email'
					type='text'
					fullWidth
					required
					onChange={(e) => handleChange(e.target.value, 'email')}
					value={formData?.email ? formData.email : ''}
					error={errorObj?.email ? true : false}
					helperText={errorObj?.email}
				/>}
				<TextField
					margin='dense'
					variant='standard'
					id='phoneNumber'
					label='Phone Number'
					type='text'
					fullWidth
					onChange={(e) => handleChange(e.target.value, 'phoneNumber')}
					value={formData?.phoneNumber ? formData.phoneNumber : ''}
					error={errorObj?.phoneNumber ? true : false}
					helperText={errorObj?.phoneNumber}
				/>
				<TextField
					margin='dense'
					variant='standard'
					id='teamName'
					label='Team Name'
					type='text'
					fullWidth
					onChange={(e) => handleChange(e.target.value, 'teamName')}
					value={formData?.teamName ? formData.teamName : ''}
					error={errorObj?.teamName ? true : false}
					helperText={errorObj?.teamName}
				/>
				{(!data || data === null || (data && data.licenses.length==0)) &&
				<TextField
					margin='dense'
					variant='standard'
					id='userType'
					label='User Type'
					type='text'
					select
					fullWidth
					onChange={(e) => handleChange(e.target.value, 'userType')}
					value={formData?.userType ? formData.userType : ''}
					error={errorObj?.userType ? true : false}
					helperText={errorObj?.userType}
				>
					<MenuItem value=''>
						Select User Type
					</MenuItem>
					<MenuItem value='TeamAgent'>
						Team Agent
					</MenuItem>
					<MenuItem value='SalesAgent'>
						Sales Agent
					</MenuItem>
					<MenuItem value='Customer'>
						Customer
					</MenuItem>
				</TextField>
				}
				{(!data || data === null) &&
				<TextField
					margin='dense'
					variant='standard'
					id='password'
					label='Password'
					type='password'
					fullWidth
					required
					onChange={(e) => handleChange(e.target.value, 'password')}
					value={formData?.password ? formData.password : ''}
					error={errorObj?.password ? true : false}
					helperText={errorObj?.password}
				/>}
				<FormControlLabel
					control={
						<Checkbox checked={formData.isUnlimitedAccess} onChange={handleCheckboxChange} name='isUnlimitedAccess' />
					}
					label='Unlimited Access'
					labelPlacement='start'
				/>
			</DialogContent>
			<DialogActions>
				<Button onClick={handleClose}>Cancel</Button>
				<Button onClick={handleSubmit}>{data && data !== null ? 'Update' : 'Save'}</Button>
			</DialogActions>
		</Dialog>
	);
};

export default CreateUser;
